const _nullsLastComparator = (a, b, direction) => {
  if (a === null && b === null) return 0;
  if (a === null) return 1;
  if (b === null) return -1;

  if (direction === 'asc') {
    return a > b ? 1 : a < b ? -1 : 0;
  }

  return a < b ? 1 : a > b ? -1 : 0;
};

export default function orderBy(items, fields, directions) {
  return items.sort((itemA, itemB) => {
    for (let i = 0; i < fields.length; i += 1) {
      const field = fields[i];
      const direction = directions[i];

      const valueA = itemA[field];
      const valueB = itemB[field];

      const result = _nullsLastComparator(valueA, valueB, direction);
      if (result !== 0) {
        return result;
      }
    }
    return 0;
  });
}
